var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChevronUp = function SvgIconChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 15.75L12.75 10.75L7.75 15.75",
    strokeWidth: 3
  })));
};
export default SvgIconChevronUp;